/**
 * @file index.js
 * @author Alvaro Martinez
 * @description Initialize Proteinuria Details List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './DissentWithoutPsychologyAssessmentListView';

export const mapStateToPropsDissentWithoutPsychologyAssessmentsList =
  mapStateToProps;
export const mapDispatchToPropsDissentWithoutPsychologyAssessmentsList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsDissentWithoutPsychologyAssessmentsList,
  mapDispatchToPropsDissentWithoutPsychologyAssessmentsList
)(View);
